import styled from 'styled-components';

const EmptyVoucher = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .image-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
    img{
      object-fit: contain;
      width: 75%;
      max-width: 336px;
    }
  }
  .text{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    p{
      font-family: 'DMSans-Bold';
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #242424;
      margin-bottom: 10px;
      &:nth-child(2){
        font-family: 'DMSans-Regular';
        font-weight: normal;
        margin-bottom: 0;
      }
    }
  }
  .refresh-button{
    border: none;
    border-radius: 22px;
    background-color: #159953;
    width: 100%;
    max-width: 189px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 70px;
    p{
      font-family: 'DMSans-Bold';
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
      margin: 0;
    }
  }
`

export default EmptyVoucher;